import { render, staticRenderFns } from "./IrgToolPage.vue?vue&type=template&id=5e274faf&scoped=true&"
import script from "./IrgToolPage.vue?vue&type=script&lang=js&"
export * from "./IrgToolPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e274faf",
  null
  
)

export default component.exports